import { ReactNode } from "react"
import {
  Button,
  ButtonProps,
  StackProps,
  TextProps,
  VStack,
} from "@chakra-ui/react"

import TransactionProgressLoader from "#/shared/components/TransactionProgressLoader"
import TransactionRejected from "#/shared/components/TransactionRejected"

type FormSubmitButtonProps = StackProps & {
  hasError: boolean
  isLoading: boolean
  buttonProps?: ButtonProps
  loaderButtonProps?: ButtonProps
  rejectedButtonProps?: TextProps
  loaderText?: string
  children: ReactNode
}

export default function FormSubmitButton({
  hasError,
  isLoading,
  buttonProps,
  loaderButtonProps,
  rejectedButtonProps,
  loaderText = "Waiting for transaction...",
  children,
  ...props
}: FormSubmitButtonProps) {
  const finalButtonProps = isLoading
    ? { ...buttonProps, ...loaderButtonProps }
    : buttonProps

  return (
    <VStack {...props}>
      {hasError && !isLoading && (
        <TransactionRejected
          showIcon={false}
          rejectedText="Transaction rejected"
          textProps={rejectedButtonProps}
        />
      )}
      <Button
        variant={finalButtonProps?.isDisabled ? "disabled" : "primary"}
        size="large"
        type="submit"
        {...finalButtonProps}
      >
        {isLoading ? <TransactionProgressLoader text={loaderText} /> : children}
      </Button>
    </VStack>
  )
}
